import { call, put, select, takeLatest } from 'redux-saga/effects'

import { IAgentSourcedCreator, IAgentSourcedCreatorMeta } from '@components/CreatorSearch/types'
import { IHateoasLink } from '@store'
import {
  fetchAgentSourcedCreatorsByToken,
  fetchAgentSourcedCreatorsFailure,
  fetchAgentSourcedCreatorsSuccess,
} from '@store/agentSourcedCreators/actions'
import { selectShareableSourcedCreatorsShortlistLink } from '@store/rootResource'
import { networkRequest } from '@utils/networkRequest'

interface IFetchResponse {
  items: IAgentSourcedCreator[]
  links?: IHateoasLink[]
  metadata?: IAgentSourcedCreatorMeta | null
}

export function* fetchCreatorsByTokenSaga(
  action: ReturnType<typeof fetchAgentSourcedCreatorsByToken>,
) {
  try {
    const { token } = action.payload
    const link: IHateoasLink | undefined = yield select(selectShareableSourcedCreatorsShortlistLink)
    if (!link) {
      throw new Error(
        "HATEOAS link 'shareable_sourced_creators_shortlist' not found on rootResource",
      )
    }
    const href = link.href.replace('{token}', token)
    const response: IFetchResponse = yield call(
      networkRequest,
      link.method,
      href,
      undefined,
      undefined,
    )
    yield put(
      fetchAgentSourcedCreatorsSuccess({
        creators: response.items,
        collectionLinks: response.links ?? [],
        metadata: response.metadata ?? null,
      }),
    )
  } catch (e: any) {
    yield put(fetchAgentSourcedCreatorsFailure(e?.message ?? 'Failed to load creators'))
  }
}

export default function* watchFetchAgentSourcedCreatorsByToken() {
  yield takeLatest(fetchAgentSourcedCreatorsByToken.type, fetchCreatorsByTokenSaga)
}
